// ========== POPUP ==========
const popupLinks = document.querySelectorAll(".popup-link");
const lockPadding = document.querySelectorAll(".lock-padding");
const inputData = document.querySelectorAll('.select__current-input');
const timeout = 800;
let unlock = true;

if (popupLinks.length > 0) {
	for (let index = 0; index < popupLinks.length; index++) {
		const popupLink = popupLinks[index];
		popupLink.addEventListener("click", (e) => {

			const popupName = popupLink.getAttribute("data-popup");
			const currentPopup = document.getElementById(popupName);
			popupOpen(currentPopup);
			e.preventDefault();
		});
	}
}

const popupCloseIcons = document.querySelectorAll(".close-popup");
if (popupCloseIcons.length > 0) {
	for (let index = 0; index < popupCloseIcons.length; index++) {
		const popupCloseIcon = popupCloseIcons[index];
		popupCloseIcon.addEventListener("click", (e) => {
			popupClose(popupCloseIcon.closest(".popup"));
			e.preventDefault();
		});
	}
}

function popupOpen(currentPopup) {
	if (currentPopup && unlock) {
           onOpenDo(currentPopup)
		const popupActive = document.querySelector(".popup.open");
		if (popupActive) {
			popupClose(popupActive, false);
		} else {
			bodyLock();
		}
		currentPopup.classList.add("open");
		currentPopup.addEventListener("mousedown", (e) => {
			if (e.target.closest(".popup__body") && !e.target.closest(".popup__content")) {
				popupClose(e.target.closest(".popup"));
			}
		});
	}
}

function popupClose(popupActive, doUnlock = true) {
	if (unlock) {
		popupActive.classList.remove("open");
		if (doUnlock) {
			bodyUnLock();
		}
	}
}

function bodyLock() {
	const lockPaddingValue = window.innerWidth - document.querySelector("body").offsetWidth + "px";
	if (lockPadding.length > 0) {
		for (let index = 0; index < lockPadding.length; index++) {
			const element = lockPadding[index];
			element.style.paddingRight = lockPaddingValue;
		}
	}
	document.body.style.paddingRight = lockPaddingValue;
	document.body.classList.add("lock");
	unlock = false;
	setTimeout(function () {
		unlock = true;
	}, timeout);
}

function bodyUnLock() {
	setTimeout(function () {
		for (let index = 0; index < lockPadding.length; index++) {
			const element = lockPadding[index];
			element.style.paddingRight = "0px";
		}
		document.body.style.paddingRight = "0px";
		document.body.classList.remove("lock");
	}, timeout);
	unlock = false;
	setTimeout(function () {
		unlock = true;
	}, timeout);
}

document.addEventListener("keydown", closeKey);

function closeKey(e) {
	if (e.code === "Escape") {
		const popupActive = document.querySelector(".popup.open");
		popupClose(popupActive);
	}
}

(function () {
	if (!Element.prototype.closest) {
		Element.prototype.closest = function (css) {
			var node = this;
			while (node) {
				if (node.matches(css)) {
					return node;
				} else node = node.parentElement;
			}
			return null;
		};
	}
})(function () {
	if (!Element.prototype.matches) {
		Element.prototype.matches =
			Element.prototype.matchesSelector ||
			Element.prototype.webkitMatchesSelector ||
			Element.prototype.mozMatchesSelector ||
			Element.prototype.msMatchesSelector ||
			Element.prototype.oMatchesSelector;
	}
});

  function onOpenDo(currentPopup) {
    if (currentPopup.getAttribute("id") == "popup-form") {
      if (document.querySelector('.product-content__main-title')) {
        const text = document.querySelector('.product-content__main-title').innerText;
        const input = document.querySelector('input[name="contact[product-name]"]');
        input.value = text;
    }
  }
  }

// ========== Select ==========
let useSelect = function () {
	let selectWrapper = document.querySelectorAll(".select");
	let selectHeader = document.querySelectorAll(".select__header");
	let selectBody = document.querySelector(".select__body");
	let selectItems = document.querySelectorAll(".select__item");
	setSelectBodyHeight();
	selectHeader.forEach((item) => {
		item.addEventListener("click", selectToggle);
	});

	selectItems.forEach((item) => {
		item.addEventListener("click", selectChoose);
	});

	function selectToggle() {
		this.parentElement.classList.toggle("is-active");
		setSelectBodyHeight();
	}

	function setSelectBodyHeight() {
		let selectBodyHeight = selectBody.scrollHeight;
		document.documentElement.style.setProperty("--height-filter-select-body", `${selectBodyHeight}px`);
	}

	function selectChoose() {
       
		let text = this.innerText;
		let measurement = this.getAttribute("data-measurement")
			select = this.closest(".select"),
			currentText = select.querySelector(".select__current"),
			currentValue = select.querySelector(".select__current-input");
		// console.log(this.parentElement.previousElementSibling.children[1])
		this.parentElement.previousElementSibling.children[1].value = currentValue
		currentText.innerText = text;
		currentText.setAttribute("data-measurement", measurement )
		currentValue.value = measurement;
		select.classList.remove("is-active");
	}

	document.addEventListener("mousedown", (e) => {
		selectWrapper.forEach((select) => {
			if (e.target.closest(".select") != select) {
				select.classList.remove("is-active");
			}
		});
	});
};

useSelect();



